export default __webpack_public_path__ + "static/media/Studying-hover.2d1fcd54.svg";